<div class="td-cnt-ext-extra-cost">
    <div class="td-cnt-extra-cost">
        <div class="td-cnt-title">
            <span class="te-title">{{'enquiryBook.extraCosts' | translate}}</span>
        </div>
        <div class="td-cnt-body-dto">

            <div style="max-height: 40vh;overflow: auto;">
                <div *ngFor="let opt of extraNewOptions; let i = index" class="extra-cost-item">

                    <!-- Extra Cost Select Dropdown  (onSelected)="onExtraCostChange($event.value, i)" -->

                    <div style="min-width: 20vw;">
                        <teiasoft-select [labelText]="'grid.extraCost' | translate" [isMobile]="isMobile"
                            [disabled]="false" 
                            [optionsList]="extraCostsOptionsList"
                            [spaceLabel]="true"
                            [noMinWidth]="true" [isValid]="true" [readOnly]="false" [isRequired]="true"
                            (onSelected)="onExtraCostChange($event.value, opt)"
                            [defaultValue]="opt.value"></teiasoft-select>
                    </div>

                    <div class="row-actions" *ngIf="opt.value">
                        <button class="teia-tt-button tb-primary" (click)="removeExtraCost(i)"><i
                                class="fal fa-trash"></i></button>
                    </div>
                    <!-- </div> -->
                </div>


            </div>
            <div>
                <!-- Add Extra Cost Button -->

            </div>
        </div>
        <button class="teia-tt-button tb-primary" (click)="addExtraCost()"><i class="fal fa-plus"></i></button>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (click)="onCancelClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [isMobile]="isMobile" class="mr-5"></teiasoft-button>
            <teiasoft-button (click)="onSaveClick()" [type]="'tb-primary'" [text]="'commons.save' | translate"
                [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>